module.exports = __webpack_public_path__ + "img/mb_block.a7243f38.png";